import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MapEntitySelection } from '../models/map-entity.model';

/** What the Atlas Rail right panel shows - the durable "what's currently
 * selected" store the app didn't have before (map redesign spec §4/§6).
 * InfoBarMapViewService (plain Subject, fires once, no retained state) and
 * the ad hoc objectData/cityData component fields it feeds are the gap this
 * fills: a late subscriber (e.g. the panel re-rendering after a zoom) can
 * read .value instead of waiting for the next click. */
@Injectable({ providedIn: 'root' })
export class MapSelectionService {
  private readonly selection$ = new BehaviorSubject<MapEntitySelection | null>(null);
  readonly selectionChanges = this.selection$.asObservable();

  select(selection: MapEntitySelection): void {
    this.selection$.next(selection);
  }

  clear(): void {
    this.selection$.next(null);
  }

  get current(): MapEntitySelection | null {
    return this.selection$.value;
  }
}
